<template>
  <!-- eslint-disable -->
  <b-sidebar
    id="add-can-bo-sidebar"
    :visible="isShowLeftSidebar"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    no-close-on-esc
    no-close-on-backdrop
    @hidden="resetForm"
    @change="(val) => $emit('update:is-show-left-sidebar', val)"
  >
    <template #default="{ hide }">
      <b-overlay :show="isWait" rounded="sm" no-fade>
        <!-- Header -->
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <h5 class="mb-0">Thông tin cán bộ</h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="hide"
          />
        </div>
        <!-- BODY -->
        <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
          <!-- Form -->
          <b-form
            id="newCBCCFrom"
            class="p-2"
            @submit.prevent="handleSubmit(onSubmit)"
            @reset.prevent="resetForm"
          >
            <div class="mb-1">
              <b-card-text class="mb-0"> Đồng bộ quốc gia </b-card-text>
              <b-form-checkbox
                v-model="formData.isSync"
                class="custom-control-primary"
                name="check-button"
                switch
                :disabled="isWait"
              >
                <span class="switch-icon-left">
                  <feather-icon icon="CheckIcon" />
                </span>
                <span class="switch-icon-right">
                  <feather-icon icon="XIcon" />
                </span>
              </b-form-checkbox>
            </div>
            <b-row>
              <div class="d-flex">
                <feather-icon icon="" size="19" />
                <h4 class="mb-0 ml-50">Cơ quan</h4>
              </div>
            </b-row>
            <b-row>
              <b-col md="6">
                <validation-provider
                  #default="validationContext"
                  name="Cơ quan quản lý CBCCVC"
                  rules="required"
                >
                  <b-form-group :state="getValidationState(validationContext)">
                    <label
                      >Cơ quan quản lý CBCCVC
                      <span style="color: red">*</span></label
                    >
                    <treeselect
                      v-on:select="format"
                      :options="DM_DONVI"
                      value-format="object"
                      v-model="valueDonViQuanLy"
                      :searchable="true"
                      :show-count="true"
                      :clearable="false"
                      :default-expand-level="1"
                      :normalizer="normalizer"
                      placeholder=""
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="6">
                <validation-provider
                  #default="validationContext"
                  name="Cơ quan sử dụng CBCCVC"
                  rules="required"
                >
                  <label
                    >Cơ quan sử dụng CBCCVC
                    <span style="color: red">*</span></label
                  >
                  <b-form-group :state="getValidationState(validationContext)">
                    <treeselect
                      v-on:select="formatDonViSuDung"
                      :options="donVis"
                      value-format="object"
                      v-model="valueDonViSuDung"
                      :searchable="true"
                      :show-count="true"
                      :clearable="false"
                      :default-expand-level="1"
                      :normalizer="normalizer"
                      placeholder=""
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="6">
                <validation-provider
                  #default="validationContext"
                  name="Cơ quan hiện tại"
                  rules="required"
                >
                  <label
                    >Cơ quan hiện tại <span style="color: red">*</span></label
                  >
                  <b-form-group :state="getValidationState(validationContext)">
                    <treeselect
                      v-on:select="formatDonVi"
                      :options="donVis"
                      value-format="object"
                      v-model="value"
                      :searchable="true"
                      :show-count="true"
                      :clearable="false"
                      :default-expand-level="1"
                      :normalizer="normalizer"
                      placeholder=""
                      @input="loadPhongBan"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col md="6">
                <validation-provider
                  #default="validationContext"
                  name="Phòng ban"
                  rules=""
                >
                  <b-form-group :state="getValidationState(validationContext)">
                    <label label-for="phongBan">Phòng ban </label>
                    <v-select
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      v-model="formData.phongBan"
                      :reduce="(val) => val"
                      :options="listPhongBan"
                      label="name"
                      :clearable="true"
                      :disabled="isWait"
                      input-id="phongBan"
                    >
                    </v-select>
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col md="6">
                <validation-provider
                  #default="{ errors }"
                  name="Ngày vào cơ quan hiện tại"
                  rules="required"
                >
                  <b-form-group
                    label-for="ngayDamNhiem"
                    :state="errors.length > 0 ? false : null"
                  >
                    <label for="ngayDamNhiem"
                      >Ngày vào cơ quan hiện tại
                      <span style="color: red">*</span></label
                    >
                    <flat-pickr
                      id="ngayDamNhiem"
                      v-model="formData.ngayDamNhiem"
                      class="form-control"
                      placeholder="__/__/____"
                      :config="{
                        wrap: true,
                        allowInput: true,
                        dateFormat: 'Y-m-d',
                        altInput: true,
                        altFormat: 'd/m/Y',
                      }"
                    />
                    <b-form-invalid-feedback
                      :state="errors.length > 0 ? false : null"
                    >
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="6">
                <validation-provider
                  #default="validationContext"
                  name="Công việc chính"
                  rules="required|max:520"
                >
                  <b-form-group :state="getValidationState(validationContext)">
                    <label label-for="congViecChinh"
                      >Công việc chính <span style="color: red">*</span></label
                    >
                    <b-form-input
                      id="congViecChinh"
                      v-model="formData.congViecChinh"
                      :state="getValidationState(validationContext)"
                      :disabled="isWait"
                      placeholder=""
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="6">
                <validation-provider
                  #default="validationContext"
                  name="Đối tượng"
                  rules="required"
                >
                  <b-form-group :state="getValidationState(validationContext)">
                    <label label-for="doiTuong"
                      >Đối tượng <span style="color: red">*</span></label
                    >
                    <v-select
                      v-model="formData.loaiHoSo"
                      label="name"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="DM_LOAIHOSO"
                      :reduce="(val) => val"
                      :clearable="true"
                      input-id="doiTuong"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="6" v-if="formData.loaiHoSo != null && formData.loaiHoSo.id == '63b590f8e97c412cb1f26660'">
                <b-form-group
                  label="Loại công chức"
                  label-for="loaiCongChuc"
                >
                  <v-select
                    v-model="formData.loaiCongChuc"
                    placeholder=""
                    label="name"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="DM_LOAICONGCHUC"
                    :reduce="(val) => val"
                    :clearable="true"
                    input-id="loaiCongChuc"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <!-- <h4 class="app-label">
              <span class="align-left">Thông tin cá nhân</span>
            </h4> -->
            <b-row>
              <div class="d-flex">
                <feather-icon icon="" size="19" />
                <h4 class="mb-0 ml-50">Thông tin cá nhân</h4>
              </div>
            </b-row>
            <b-row>
              <b-col md="6">
                <validation-provider
                  #default="validationContext"
                  name="Mã CBCCVC"
                  rules=""
                >
                  <b-form-group>
                    <label label-for="soHieuCBCCVC"
                      >Số hiệu CBCCVC (cơ quan quản lý)
                    </label>
                    <b-form-input
                      class="form-el"
                      id="soHieuCBCCVC"
                      v-model="formData.soHieuCBCCVC"
                      :state="getValidationState(validationContext)"
                      :disabled="isWait"
                      placeholder=""
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="6">
                <validation-provider
                  #default="validationContext"
                  name="Họ và Tên"
                  rules="required"
                >
                  <b-form-group>
                    <label label-for="hoVaTen"
                      >Họ và tên: <span style="color: red">*</span></label
                    >
                    <b-form-input
                      class="form-el"
                      id="hoVaTen"
                      v-model="formData.hoVaTen"
                      :state="getValidationState(validationContext)"
                      :disabled="isWait"
                      placeholder=""
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col md="6">
                <validation-provider
                  #default="validationContext"
                  name="Giới tính"
                  rules="required"
                >
                  <b-form-group :state="getValidationState(validationContext)">
                    <label label-for="gioiTinh"
                      >Giới tính <span style="color: red">*</span></label
                    >
                    <v-select
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      v-model="formData.gioiTinh"
                      :reduce="(val) => val"
                      :options="DM_GIOITINH"
                      label="name"
                      :disabled="isWait"
                      :clearable="true"
                      input-id="gioiTinh"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="6">
                <validation-provider
                  #default="validationContext"
                  name="Ngày sinh"
                  rules="required"
                >
                  <b-form-group :state="getValidationState(validationContext)">
                    <label for="ngaySinh"
                      >Ngày sinh <span style="color: red">*</span></label
                    >
                    <flat-pickr
                      v-model="formData.ngaySinh"
                      class="form-control"
                      :config="{
                        wrap: true,
                        allowInput: true,
                        dateFormat: 'Y-m-d',
                        altInput: true,
                        altFormat: 'd/m/Y',
                      }"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="6">
                <validation-provider
                  #default="validationContext"
                  name="Số CCCD"
                  rules="digits:12"
                >
                  <b-form-group>
                    <label for="soCccd"
                      >Số CCCD
                      <!-- <span style="color: red">*</span> -->
                    </label>
                    <b-form-input
                      class="form-el"
                      id="soCCCD"
                      v-model="formData.soCccd"
                      :state="getValidationState(validationContext)"
                      :disabled="isWait"
                      placeholder=""
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="6">
                <validation-provider
                  #default="validationContext"
                  name="Số CMND"
                  rules="digits:9"
                >
                  <b-form-group>
                    <label for="soCmnd"
                      >Số CMND
                      <!-- <span style="color: red">*</span> -->
                    </label>
                    <b-form-input
                      class="form-el"
                      id="soCmnd"
                      v-model="formData.soCmnd"
                      :state="getValidationState(validationContext)"
                      :disabled="isWait"
                      placeholder=""
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="4">
                <validation-provider
                  #default="validationContext"
                  name="Dân tộc"
                  rules="required"
                >
                  <b-form-group :state="getValidationState(validationContext)">
                    <label label-for="danToc"
                      >Dân tộc <span style="color: red">*</span></label
                    >
                    <v-select
                      v-model="formData.danToc"
                      label="name"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="DM_DANTOC"
                      :reduce="(val) => val"
                      :clearable="true"
                      input-id="danToc"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="4">
                <validation-provider
                  #default="validationContext"
                  name="Tôn giáo"
                  rules="required"
                >
                  <b-form-group :state="getValidationState(validationContext)">
                    <label label-for="tonGiao"
                      >Tôn giáo <span style="color: red">*</span></label
                    >
                    <v-select
                      v-model="formData.tonGiao"
                      label="name"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="DM_TONGIAO"
                      :reduce="(val) => val"
                      :clearable="true"
                      input-id="tonGiao"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="4">
                <validation-provider
                  #default="validationContext"
                  name="Tình trạng hôn nhân"
                  rules="required"
                >
                  <b-form-group :state="getValidationState(validationContext)">
                    <label label-for="tinhTrangHonNhan"
                      >Tình trạng hôn nhân
                      <span style="color: red">*</span></label
                    >
                    <v-select
                      v-model="formData.tinhTrangHonNhan"
                      label="name"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="DM_TINHTRANGHONNHAN"
                      :reduce="(val) => val"
                      :clearable="true"
                      input-id="tinhTrangHonNhan"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="4">
                <validation-provider
                  #default="validationContext"
                  name="Trình độ giáo dục phổ thông"
                  rules="required"
                >
                  <b-form-group :state="getValidationState(validationContext)">
                    <label label-for="giaoDucPhoThong"
                      >Trình độ giáo dục phổ thông
                      <span style="color: red">*</span></label
                    >
                    <v-select
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      v-model="formData.giaoDucPhoThong"
                      :reduce="(val) => val"
                      :options="DM_GIAODUCPHOTHONG"
                      label="name"
                      :disabled="isWait"
                      :clearable="true"
                      input-id="giaoDucPhoThong"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="4">
                <validation-provider
                  #default="validationContext"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-group>
                    <label label-for="email"
                      >Email <span style="color: red">*</span></label
                    >
                    <b-form-input
                      class="form-el"
                      id="email"
                      v-model="formData.email"
                      :state="getValidationState(validationContext)"
                      :disabled="isWait"
                      placeholder=""
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="4">
                <validation-provider
                  #default="validationContext"
                  name="Trạng thái hồ sơ"
                  rules=""
                >
                  <b-form-group
                    label="Trạng thái hồ sơ"
                    label-for="trangThaiHoSo"
                    :state="getValidationState(validationContext)"
                  >
                    <v-select
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      v-model="formData.trangThaiHoSo"
                      :reduce="(val) => val"
                      :options="DM_TRANGTHAIHOSO"
                      label="name"
                      :disabled="isWait"
                      :clearable="true"
                      input-id="trangThaiHoSo"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row>
              <!-- <b-col md="6">
              <validation-provider
                #default="validationContext"
                name="Chức vụ"
                rules=""
              >
                <b-form-group
                  label="Chức vụ"
                  label-for="chuVu"
                  :state="getValidationState(validationContext)"
                >
                  <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="formData.chucVu"
                    :reduce="(val) => val"
                    :options="commonData.DT_DM_CHUCVU"
                    label="name"
                    :disabled="isWait"
                    :clearable="false"
                    input-id="chucVu"
                  />
                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col> -->

              <b-col md="4" class="d-flex align-items-center">
                <b-form-group>
                  <b-form-checkbox v-model="formData.laDangVien">
                    Đảng Viên
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <validation-provider
                  #default="validationContext"
                  name="Ngày vào đảng"
                  :rules="formData.laDangVien ? 'required' : ''"
                >
                  <b-form-group :state="getValidationState(validationContext)">
                    <label label-for="ngayVaoDang"
                      >Ngày vào đảng
                      <span style="color: red" v-if="formData.laDangVien"
                        >*</span
                      ></label
                    >
                    <flat-pickr
                      v-model="formData.ngayVaoDang"
                      class="form-control"
                      :config="{
                        wrap: true,
                        allowInput: true,
                        dateFormat: 'Y-m-d',
                        altInput: true,
                        altFormat: 'd/m/Y',
                      }"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <!-- <b-col md="4">
                <validation-provider
                  #default="validationContext"
                  name="Vai trò"
                  :rules="formData.id ? '' : 'required'"
                >
                  <label label-for="roles"
                    >Vai trò
                    <span style="color: red" v-if="!formData.id">*</span></label
                  >
                  <b-form-group :state="getValidationState(validationContext)">
                    <v-select
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      v-model="formData.unitRole"
                      :reduce="(val) => val"
                      :options="roles"
                      label="name"
                      :disabled="isWait || (formData.id && formData.id != '')"
                      :clearable="true"
                      input-id="roles"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col> -->
              <b-col md="4">
                <validation-provider
                  #default="validationContext"
                  name="Số thứ tự hồ sơ"
                  rules=""
                >
                  <b-form-group :state="getValidationState(validationContext)">
                    <label for="soThuTuHoSo">Số thứ tự hồ sơ </label>
                    <b-form-input
                      class="form-el"
                      id="soThuTuHoSo"
                      v-model="formData.soThuTuHoSo"
                      :state="getValidationState(validationContext)"
                      type="number"
                      :disabled="isWait"
                      placeholder=""
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row>
              <div class="d-flex">
                <feather-icon icon="" size="19" />
                <h4 class="mb-0 ml-50">Nơi sinh</h4>
              </div>
            </b-row>
            <b-row>
              <b-col md="12">
                <validation-provider
                  #default="validationContext"
                  name="Địa chỉ nơi sinh"
                  rules="max:400"
                >
                  <b-form-group
                    label="Địa chỉ"
                    label-for="addressNS"
                    v-if="formData.noiSinh"
                  >
                    <b-form-input
                      id="addressNS"
                      v-model="formData.noiSinh.address"
                      :state="getValidationState(validationContext)"
                      :disabled="isWait"
                      placeholder="Số nhà, tổ, khóm, tên đường"
                    />

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="4">
                <validation-provider
                  #default="validationContext"
                  name="Tỉnh/TP"
                  rules="required"
                >
                  <b-form-group :state="getValidationState(validationContext)">
                    <label label-for="provinceNS"
                      >Tỉnh <span style="color: red">*</span></label
                    >
                    <v-select
                      v-model="formData.noiSinh.province"
                      label="name"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="listTinh"
                      :reduce="(val) => val"
                      :clearable="true"
                      @input="loadHuyen($event, 'noiSinh')"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="4">
                <validation-provider
                  #default="validationContext"
                  name="Huyện-NS"
                  rules=""
                >
                  <b-form-group>
                    <label label-for="dictrictNS">Huyện</label>
                    <v-select
                      v-model="formData.noiSinh.dictrict"
                      label="name"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="listHuyen.noiSinh"
                      :reduce="(val) => val"
                      :disabled="isWait || !formData.noiSinh.province"
                      :clearable="true"
                      @input="loadXa($event, 'noiSinh')"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="4">
                <validation-provider
                  #default="validationContext"
                  name="Xã-NS"
                  rules=""
                >
                  <b-form-group>
                    <label label-for="xaNS">Xã</label>
                    <v-select
                      v-model="formData.noiSinh.commune"
                      label="name"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="listXa.noiSinh"
                      :reduce="(val) => val"
                      :clearable="true"
                      :disabled="isWait || !formData.noiSinh.dictrict"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row>
              <div class="d-flex">
                <feather-icon icon="" size="19" />
                <h4 class="mb-0 ml-50">Quê quán</h4>
              </div>
            </b-row>

            <b-row>
              <b-col md="12">
                <validation-provider
                  #default="validationContext"
                  name="Quê quán theo hồ sơ gốc"
                >
                  <b-form-group label="Quê quán theo hồ sơ gốc" label-for="HSG">
                    <b-form-input
                      id="HSG"
                      v-model="formData.queQuanHoSoGoc"
                      :state="getValidationState(validationContext)"
                      :disabled="isWait"
                      placeholder=""
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="12">
                <h5>Theo đơn vị hành chính hiện nay</h5>
                <validation-provider
                  #default="validationContext"
                  name="Địa chỉ quê quán"
                  rules="max:400"
                >
                  <b-form-group
                    label="Địa chỉ"
                    label-for=""
                    v-if="formData.queQuan"
                  >
                    <b-form-input
                      id=""
                      v-model="formData.queQuan.address"
                      :state="getValidationState(validationContext)"
                      :disabled="isWait"
                      placeholder="Số nhà, tổ, khóm, tên đường"
                    />

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="4">
                <validation-provider
                  #default="validationContext"
                  name="Tỉnh quê quán"
                  rules="required"
                >
                  <b-form-group :state="getValidationState(validationContext)">
                    <label label-for="provinceQQ"
                      >Tỉnh <span style="color: red">*</span></label
                    >
                    <v-select
                      v-model="formData.queQuan.province"
                      label="name"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="listTinh"
                      :reduce="(val) => val"
                      :clearable="true"
                      @input="loadHuyen($event, 'queQuan')"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="4">
                <validation-provider
                  #default="validationContext"
                  name="Huyện quê quán"
                  rules="required"
                >
                  <b-form-group :state="getValidationState(validationContext)">
                    <label label-for="dictrictQQ"
                      >Huyện <span style="color: red">*</span></label
                    >
                    <v-select
                      v-model="formData.queQuan.dictrict"
                      label="name"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="listHuyen.queQuan"
                      :reduce="(val) => val"
                      :clearable="true"
                      :disabled="isWait || !formData.queQuan.province"
                      @input="loadXa($event, 'queQuan')"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="4">
                <validation-provider
                  #default="validationContext"
                  name="Xã-QQ"
                  rules=""
                >
                  <b-form-group label="Xã" label-for="xaQQ">
                    <v-select
                      v-model="formData.queQuan.commune"
                      label="name"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="listXa.queQuan"
                      :reduce="(val) => val"
                      :clearable="true"
                      :disabled="isWait || !formData.queQuan.dictrict"
                    />

                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row>
              <div class="d-flex">
                <feather-icon icon="" size="19" />
                <h4 class="mb-0 ml-50">Hộ khẩu thường trú</h4>
              </div>
            </b-row>
            <b-row>
              <b-col md="12">
                <validation-provider
                  #default="validationContext"
                  name="Địa chỉ hộ khẩu thường trú"
                  rules="max:400"
                >
                  <b-form-group
                    label="Địa chỉ"
                    label-for=""
                    v-if="formData.hoKhauThuongTru"
                  >
                    <b-form-input
                      id=""
                      v-model="formData.hoKhauThuongTru.address"
                      :state="getValidationState(validationContext)"
                      :disabled="isWait"
                      placeholder="Số nhà, tổ, khóm, tên đường"
                    />

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="4">
                <validation-provider
                  #default="validationContext"
                  name="Tỉnh-HKTT"
                  rules="required"
                >
                  <b-form-group :state="getValidationState(validationContext)">
                    <label label-for="province"
                      >Tỉnh <span style="color: red">*</span></label
                    >
                    <v-select
                      v-model="formData.hoKhauThuongTru.province"
                      label="name"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="listTinh"
                      :reduce="(val) => val"
                      :clearable="true"
                      @input="loadHuyen($event, 'hoKhauThuongTru')"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="4">
                <validation-provider
                  #default="validationContext"
                  name="Huyện-HKTT"
                  rules="required"
                >
                  <b-form-group :state="getValidationState(validationContext)">
                    <label label-for="dictrict"
                      >Huyện <span style="color: red">*</span></label
                    >
                    <v-select
                      v-model="formData.hoKhauThuongTru.dictrict"
                      label="name"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="listHuyen.hoKhauThuongTru"
                      :reduce="(val) => val"
                      :clearable="true"
                      :disabled="isWait || !formData.hoKhauThuongTru.province"
                      @input="loadXa($event, 'hoKhauThuongTru')"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="4">
                <validation-provider
                  #default="validationContext"
                  name="Xã-HKTT"
                  rules=""
                >
                  <b-form-group label="Xã" label-for="commune">
                    <v-select
                      v-model="formData.hoKhauThuongTru.commune"
                      label="name"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="listXa.hoKhauThuongTru"
                      :reduce="(val) => val"
                      :clearable="true"
                      input-id="commune"
                      :disabled="isWait || !formData.hoKhauThuongTru.dictrict"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row>
              <div class="d-flex">
                <feather-icon icon="" size="19" />
                <h4 class="mb-0 ml-50">Nơi ở hiện nay</h4>
              </div>
            </b-row>
            <b-row>
              <b-col md="12">
                <validation-provider
                  #default="validationContext"
                  name="Địa chỉ nơi ở"
                  rules="max:400"
                >
                  <b-form-group
                    label="Địa chỉ"
                    label-for=""
                    v-if="formData.noiO"
                  >
                    <b-form-input
                      id=""
                      v-model="formData.noiO.address"
                      :state="getValidationState(validationContext)"
                      :disabled="isWait"
                      placeholder="Số nhà, tổ, khóm, tên đường"
                    />

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="4">
                <validation-provider
                  #default="validationContext"
                  name="Tỉnh nơi ở hiện nay"
                  rules="required"
                >
                  <b-form-group :state="getValidationState(validationContext)">
                    <label label-for="province"
                      >Tỉnh <span style="color: red">*</span></label
                    >
                    <v-select
                      v-model="formData.noiO.province"
                      label="name"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="listTinh"
                      :reduce="(val) => val"
                      :clearable="true"
                      @input="loadHuyen($event, 'noiO')"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="4">
                <validation-provider
                  #default="validationContext"
                  name="Huyện nơi ở hiện nay"
                  rules="required"
                >
                  <b-form-group :state="getValidationState(validationContext)">
                    <label label-for="dictrict"
                      >Huyện <span style="color: red">*</span></label
                    >
                    <v-select
                      v-model="formData.noiO.dictrict"
                      label="name"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="listHuyen.noiO"
                      :reduce="(val) => val"
                      :clearable="true"
                      :disabled="isWait || !formData.noiO.province"
                      @input="loadXa($event, 'noiO')"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="4">
                <validation-provider
                  #default="validationContext"
                  name="Xã"
                  rules="required"
                >
                  <b-form-group :state="getValidationState(validationContext)">
                    <label label-for="xa"
                      >Xã <span style="color: red">*</span></label
                    >
                    <v-select
                      v-model="formData.noiO.commune"
                      label="name"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="listXa.noiO"
                      :reduce="(val) => val"
                      :clearable="true"
                      :disabled="isWait || !formData.noiO.dictrict"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>

            <!-- <h4 class="app-label">
            <span class="align-left">Ngạch, bậc, chức vụ</span>
          </h4>
          <b-row>
            
            <b-col md="6">
              <validation-provider
                #default="validationContext"
                name="Chức vụ"
                rules=""
              >
                <b-form-group
                  label="Chức vụ"
                  label-for="chuVu"
                  :state="getValidationState(validationContext)"
                >
                  <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="formData.chucVu"
                    :reduce="(val) => val"
                    :options="commonData.DT_DM_CHUCVU"
                    label="name"
                    :disabled="isWait"
                    :clearable="false"
                    input-id="chucVu"
                  />
                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col md="6">
              <validation-provider
                #default="validationContext"
                name="Trạng thái hồ sơ"
                rules=""
              >
                <b-form-group
                  label="Trạng thái hồ sơ"
                  label-for="trangThaiHoSo"
                  :state="getValidationState(validationContext)"
                >
                  <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="formData.trangThaiHoSo"
                    :reduce="(val) => val"
                    :options="commonData.DM_TRANGTHAIHOSO"
                    label="name"
                    :disabled="isWait"
                    :clearable="false"
                    input-id="trangThaiHoSo"
                  />
                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

          
            <b-col md="4" class="d-flex align-items-center">
              <b-form-group>
                <b-form-checkbox v-model="formData.laDangVien">
                  Đảng Viên
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <validation-provider
                #default="validationContext"
                name="Ngày vào đảng"
                :rules="formData.laDangVien ? 'required' : ''"
              >
                <b-form-group :state="getValidationState(validationContext)">
                  <label label-for="ngayVaoDang"
                    >Ngày vào đảng
                    <span style="color: red" v-if="formData.laDangVien"
                      >*</span
                    ></label
                  >
                  <flat-pickr
                    v-model="formData.ngayVaoDang"
                    class="form-control"
                    :config="{
                      wrap: true,
                      allowInput: true,
                      dateFormat: 'Y-m-d',
                      altInput: true,
                      altFormat: 'd/m/Y',
                    }"
                  />
                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row> -->

            <!-- <h4 class="app-label">
            <span class="align-left">Trình độ đào tạo</span>
          </h4>
          <b-row>
           
            <b-col md="6">
              <validation-provider
                #default="validationContext"
                name="Trình độ chuyên môn cao nhất"
                rules=""
              >
                <b-form-group
                  label="Trình độ chuyên môn cao nhất"
                  label-for="trinhDoHocVan"
                  :state="getValidationState(validationContext)"
                >
                  <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="formData.trinhDoCaoNhat"
                    :reduce="(val) => val"
                    :options="commonData.DM_TRINHDODAOTAO"
                    label="name"
                    :disabled="isWait"
                    :clearable="false"
                    input-id="trinhDoHocVan"
                  />
                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col md="6">
              <validation-provider
                #default="validationContext"
                name="Lý luận chính trị"
                rules=""
              >
                <b-form-group
                  label="Lý luận chính trị"
                  label-for="lyLuanChinhTri"
                  :state="getValidationState(validationContext)"
                >
                  <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="formData.lyLuanChinhTri"
                    :reduce="(val) => val"
                    :options="commonData.DM_TRINHDOLLCT"
                    label="name"
                    :disabled="isWait"
                    :clearable="false"
                    input-id="lyLuanChinhTri"
                  />
                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="validationContext"
                name="Quản lý nhà nước"
                rules=""
              >
                <b-form-group
                  label="Quản lý nhà nước"
                  label-for="quanLyNhaNuoc"
                  :state="getValidationState(validationContext)"
                >
                  <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="formData.quanLyNhaNuoc"
                    :reduce="(val) => val"
                    :options="commonData.DM_TRINHDOQLNN"
                    label="name"
                    :disabled="isWait"
                    :clearable="false"
                    input-id="quanLyNhaNuoc"
                  />
                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="validationContext"
                name="Trình độ tiếng anh"
                rules=""
              >
                <b-form-group
                  label="Trình độ tiếng anh"
                  label-for="tiengAnh"
                  :state="getValidationState(validationContext)"
                >
                  <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="formData.tiengAnh"
                    :reduce="(val) => val"
                    :options="commonData.DM_TRINHDONGOAINGU"
                    label="name"
                    :disabled="isWait"
                    :clearable="false"
                    input-id="tiengAnh"
                  />
                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="validationContext"
                name="Trình độ tin học"
                rules=""
              >
                <b-form-group
                  label="Trình độ tin học"
                  label-for="tinHoc"
                  :state="getValidationState(validationContext)"
                >
                  <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="formData.tinHoc"
                    :reduce="(val) => val"
                    :options="commonData.DM_TRINHDOTINHOC"
                    label="name"
                    :disabled="isWait"
                    :clearable="false"
                    input-id="tinHoc"
                  />
                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="12">
              <validation-provider
                #default="validationContext"
                name="Ngoại ngữ khác"
                rules=""
              >
                <b-form-group
                  label="Ngoại ngữ khác"
                  label-for="ngoaiNgu"
                  :state="getValidationState(validationContext)"
                >
                  <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="formData.ngoaiNgu"
                    multiple
                    :reduce="(val) => val"
                    :options="commonData.DM_NGOAINGU"
                    label="name"
                    :disabled="isWait"
                    :clearable="false"
                    input-id="ngoaiNgu"
                  />
                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row> -->

            <b-row>
              <b-col md="12">
                <div class="mt-2 text-right">
                  <b-button
                    v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                    type="button"
                    variant="outline-secondary"
                    class="mr-2"
                    :disabled="isWait"
                    @click="hide"
                  >
                    Hủy
                  </b-button>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    :disabled="isWait"
                    type="submit"
                  >
                    Lưu lại
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-overlay>
    </template>
  </b-sidebar>
</template>

<script>
/* eslint-disable */
import {
  BRow,
  BCol,
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BFormDatepicker,
  BFormCheckbox,
  BOverlay,
  BCardText,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import { required, alphaNum, email, url } from "@validations";
import formValidation from "@core/comp-functions/forms/form-validation";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import flatPickr from "vue-flatpickr-component";
import flatpickr from "flatpickr";
import { Vietnamese } from "flatpickr/dist/l10n/vn.js";
import {
  CanBoCongChucCreate as dataCreate,
  CanBoCongChucUpdate as dataUpdate,
} from "@/services/api/HoSoCanBoCongChuc/CanBoCongChucService";
import { GetInfoByEmail } from "@/services/api/DefaultTemplate/UserService";
import { PhongBanGetList } from "@/services/api/DefaultTemplate/PhongBanService";
import {
  GetTreeDVSD,
  GetTreeAll,
} from "@/services/api/DefaultTemplate/DonViService";
import { GetUserInfo } from "@/services/api/DefaultTemplate/AuthService";
// import { GetTreeAll } from "@/services/api/DefaultTemplate/DonViService";

import { ref, computed, watch } from "@vue/composition-api";
import Treeselect from "@riophae/vue-treeselect";
import useSetup from "../useSetup";
import vi from "vee-validate/dist/locale/vi.json";
localize("vi", vi);

flatpickr.localize(Vietnamese);
const defaultData = {
  id: null,
  name: null,
  code: null,
};

const defaultLoaiHoSo = {
  id: "63b590f8e97c412cb1f26660",
  name: "Công chức",
  code: "02",
};

const province = {
  id: "63f585c17b5b00ac9b950146",
  name: "Tỉnh Đồng Tháp",
  code: "87",
};

const defaultAddress = {
  address: "",
  commune: null,
  dictrict: null,
  province: province,
};

export default {
  components: {
    Treeselect,
    flatPickr,
    BRow,
    BCol,
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    BFormDatepicker,
    BFormCheckbox,
    BOverlay,
    BCardText,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    donVis: {
      type: Array,
      required: true,
    },
    donViDefaultSelected: {
      type: Object,
    },
    formData: {
      type: Object,
      default: {},
      required: true,
    },
    isShowLeftSidebar: {
      type: Boolean,
      required: true,
    },
    roles: {
      type: Array,
      required: true,
    },
  },
  created() {
    this.getListTree();
    this.loadInfoUser();
    this.loadTinh();
    this.loadHuyenCreate();
    //TODO set Defaut ==================
    // this.formData.gioiTinh = Object.assign({}, defaultData);
    this.formData.phongBan = Object.assign({}, defaultData);

    this.formData.noiSinh = Object.assign({}, defaultAddress);
    this.formData.queQuan = Object.assign({}, defaultAddress);
    this.formData.noiO = Object.assign({}, defaultAddress);
    this.formData.hoKhauThuongTru = Object.assign({}, defaultAddress);
    Vietnamese.months.longhand = this.longhand;
  },
  watch: {
    isShowLeftSidebar(val) {
      // console.log("roles", this.roles);
      // console.log("val isShowLeftSidebar", this.formData);

      if (val) {
        this.fnGetGioiTinh();
        this.fnGetDanToc();
        this.fnGetTonGiao();
        this.fnGetTinhTrangHonNhan();
        this.fnGetNgachChucDanh();
        this.fnGetChucVu();
        this.fnGetGiaoDucPhoThong();
        this.fnGetTrinhDoLyLuanChinhTri();
        this.fnGetTrinhDoQuanLyNhaNuoc();
        this.fnGetTrinhDoNgoaiNgu();
        this.fnGetTrinhDoTinHoc();
        this.fnGetLoaiHoSo();
        this.fnGetLoaiCongChuc();
        this.fnGetNgoaiNgu();
        this.fnGetTrangThaiHoSo();
        if (this.formData && this.formData.id) {
          if (this.formData.donVi && this.formData.donVi.id) {
            this.value = {
              id: this.formData.donVi.id,
              label: this.formData.donVi.ten,
              maCoQuan: this.formData.donVi.maCoQuan,
              isSyncQG: this.formData.donVi.isSyncQG,
            };
          }
          if (this.formData.donViSuDung && this.formData.donViSuDung.id) {
            this.valueDonViSuDung = {
              id: this.formData.donViSuDung.id,
              label: this.formData.donViSuDung.ten,
              maCoQuan: this.formData.donViSuDung.maCoQuan,
              isSyncQG: this.formData.donViSuDung.isSyncQG,
            };
          }
          if (this.formData.donViQuanLy && this.formData.donViQuanLy.id) {
            this.valueDonViQuanLy = {
              id: this.formData.donViQuanLy.id,
              label: this.formData.donViQuanLy.ten,
              maCoQuan: this.formData.donViQuanLy.maCoQuan,
              isSyncQG: this.formData.donViQuanLy.isSyncQG,
            };
            // this.loadDVSD(this.valueDonViQuanLy, true);
          }

          //  TODO : Auto load Address
          // let key = ["noiSinh", "queQuan", "hoKhauThuongTru", "noiO"];
          // key.map((item) => {
          //   if (this.formData[item] && this.formData[item].province) {
          //     this.loadHuyen(this.formData[item].province, item, (data) => {
          //       if (this.formData[item].dictrict) {
          //         this.loadXa(this.formData[item].dictrict, item, (data) => {});
          //       }
          //     });
          //   }
          // });
        } else {
          // this.value = this.donViDefaultSelected;
          // this.valueDonViQuanLy = this.donViDefaultSelected;
          // console.log("donViDefaultSelected", this.donViDefaultSelected);
          // if (this.donViDefaultSelected) {
          //   this.formData.donVi = {
          //     id: this.donViDefaultSelected.id,
          //     ten: this.donViDefaultSelected.label,
          //     maCoQuan: this.donViDefaultSelected.maCoQuan,
          //     isSyncQG: this.formData.donViDefaultSelected.isSyncQG,
          //   };
          //   this.formData.donViQuanLy = {
          //     id: this.donViDefaultSelected.id,
          //     ten: this.donViDefaultSelected.label,
          //     maCoQuan: this.donViDefaultSelected.maCoQuan,
          //     isSyncQG: this.formData.donViDefaultSelected.isSyncQG,
          //   };
          // }
          this.value = null;
          this.valueDonViSuDung = null;
          this.valueDonViQuanLy = null;
          this.formData.soThuTuHoSo = 0;
          this.formData.isSync = true;

          if (this.formData.phongBan == null) {
            this.formData.phongBan = Object.assign({}, defaultData);
          }
          this.formData.noiSinh = Object.assign({}, defaultAddress);
          this.formData.queQuan = Object.assign({}, defaultAddress);
          this.formData.noiO = Object.assign({}, defaultAddress);
          this.formData.hoKhauThuongTru = Object.assign({}, defaultAddress);
        }
        this.formData.isUpdatedSyncQuocGia = true;
        let key = ["noiSinh", "queQuan", "hoKhauThuongTru", "noiO"];
        key.map((item) => {
          if (this.formData[item] && this.formData[item].province) {
            this.loadHuyen(this.formData[item].province, item, (data) => {
              if (this.formData[item].dictrict) {
                this.loadXa(this.formData[item].dictrict, item, (data) => {});
              }
            });
          }
        });
        console.log("this.formData", this.formData);
      }
    },
  },
  data() {
    return {
      isWait: false,
      value: null,
      valueDonViSuDung: null,
      valueDonViQuanLy: null,
      DM_DONVI: [],
      listPhongBan: [],
      listDVSD: [],
      required,
      alphaNum,
      email,
      url,
      listTinh: [],
      DM_LOAICONGCHUC: [],
      listHuyen: {
        queQuan: [],
        noiSinh: [],
        noiO: [],
        hoKhauThuongTru: [],
      },
      listXa: {
        queQuan: [],
        noiSinh: [],
        noiO: [],
        hoKhauThuongTru: [],
      },
      longhand: [
        "Tháng 1",
        "Tháng 2",
        "Tháng 3",
        "Tháng 4",
        "Tháng 5",
        "Tháng 6",
        "Tháng 7",
        "Tháng 8",
        "Tháng 9",
        "Tháng 10",
        "Tháng 11",
        "Tháng 12",
      ],
      infoUser: null,
      DM_GIOITINH: [],
      DM_DANTOC: [],
      DM_TONGIAO: [],
      DM_TINHTRANGHONNHAN: [],
      DM_NGACHCHUCDANH: [],
      DT_DM_CHUCVU: [],
      DM_GIAODUCPHOTHONG: [],
      DM_TRINHDODAOTAO: [],
      DM_TRINHDOLLCT: [],
      DM_TRINHDOQLNN: [],
      DM_TRINHDONGOAINGU: [],
      DM_TRINHDOTINHOC: [],
      DM_NGOAINGU: [],
      DM_TRANGTHAIHOSO: [],
      DM_LOAIHOSO: [],
    };
  },
  mounted() {},

  methods: {
    fnGetLoaiCongChuc() {
      this.$store.dispatch("common/fetchLoaiCongChuc").then((response) => {
        this.DM_LOAICONGCHUC = response;
      });
    },
    getListTree() {
      GetTreeAll().then((res) => {
        // console.log("res", res);
        if (res.isError) {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Thất bại",
              icon: "AlertTriangleIcon",
              variant: "error",
              text: res.message,
            },
          });
        } else {
          this.DM_DONVI = res.data;
        }
      });
    },
    fnGetGioiTinh() {
      this.$store.dispatch("common/fetchGioiTinh").then((response) => {
        this.DM_GIOITINH = response;
        // console.log("DM_GIOITINH", this.DM_GIOITINH);
      });
    },
    fnGetDanToc() {
      this.$store.dispatch("common/fetchDanToc").then((response) => {
        this.DM_DANTOC = response;
        if (this.formData && !this.formData.danToc)
          this.formData.danToc = response?.find((x) => x.code == "01");
      });
    },
    fnGetTonGiao() {
      this.$store.dispatch("common/fetchTonGiao").then((response) => {
        this.DM_TONGIAO = response;
        if (this.formData && !this.formData.tonGiao)
          this.formData.tonGiao = response?.find((x) => x.code == "99");
      });
    },
    fnGetTinhTrangHonNhan() {
      this.$store.dispatch("common/fetchTinhTrangHonNhan").then((response) => {
        this.DM_TINHTRANGHONNHAN = response;
      });
    },
    fnGetNgachChucDanh() {
      this.$store.dispatch("common/fetchNgachChucDanh").then((response) => {
        this.DM_NGACHCHUCDANH = response;
      });
    },
    fnGetChucVu() {
      this.$store.dispatch("common/fetchChucVu").then((response) => {
        this.DT_DM_CHUCVU = response;
      });
    },
    fnGetGiaoDucPhoThong() {
      this.$store.dispatch("common/fetchGiaoDucPhoThong").then((response) => {
        this.DM_GIAODUCPHOTHONG = response;
        if (this.formData && !this.formData.giaoDucPhoThong)
          this.formData.giaoDucPhoThong = response?.find((x) => x.code == "22");
      });
    },
    fnGetTrinhDoDaoTao() {
      this.$store.dispatch("common/fetchTrinhDoDaoTao").then((response) => {
        this.DM_TRINHDODAOTAO = response;
      });
    },
    fnGetTrinhDoLyLuanChinhTri() {
      this.$store
        .dispatch("common/fetchTrinhDoLyLuanChinhTri")
        .then((response) => {
          this.DM_TRINHDOLLCT = response;
        });
    },
    fnGetTrinhDoQuanLyNhaNuoc() {
      this.$store
        .dispatch("common/fetchTrinhDoQuanLyNhaNuoc")
        .then((response) => {
          this.DM_TRINHDOQLNN = response;
        });
    },
    fnGetTrinhDoNgoaiNgu() {
      this.$store.dispatch("common/fetchTrinhDoNgoaiNgu").then((response) => {
        this.DM_TRINHDONGOAINGU = response;
      });
    },
    fnGetTrinhDoTinHoc() {
      this.$store.dispatch("common/fetchTrinhDoTinHoc").then((response) => {
        this.DM_TRINHDOTINHOC = response;
      });
    },
    fnGetNgoaiNgu() {
   //   console.log("LOG VAO NGOAI NGU HS CREATE")
      this.$store.dispatch("common/fetchNgoaiNgu").then((response) => {
        this.DM_NGOAINGU = response;
      });
    },
    fnGetTrangThaiHoSo() {
 //     console.log("LOG VAO TRANG THAI HS CREATE")
      this.$store.dispatch("common/fetchTrangThaiHoSo").then((response) => {
        this.DM_TRANGTHAIHOSO = response;
   //     console.log("LOG VAO TRANG THAI HS CREATE VAO TRONG " , this.DM_TRANGTHAIHOSO)
        if (
          this.formData &&
          (this.formData.trangThaiHoSo == undefined ||
            this.formData.trangThaiHoSo == null)
        )
          this.formData.trangThaiHoSo = response?.find((x) => x.code == "01");
      });
    },
    fnGetLoaiHoSo() {
      this.$store.dispatch("common/fetchLoaiHoSo").then((response) => {
        this.DM_LOAIHOSO = response;
        console.log("DM_LOAIHOSO", response);
      });
    },
    loadInfoUser() {
      this.infoUser = GetUserInfo();
      console.log("this.infoUser", this.infoUser);
    },
    loadHuyenCreate() {
      this.$store
        .dispatch("common/fetchDiaGioiHanhChinh", {
          id: "87",
        })
        .then((response) => {
          this.listHuyen.noiSinh = response;
          this.listHuyen.queQuan = response;
          this.listHuyen.hoKhauThuongTru = response;
          this.listHuyen.noiO = response;
        });
      // console.log("loadHuyen", this.listHuyen);
    },
    format(node, instanceId) {
      // console.log("node", node);
      this.formData.donViQuanLy = {
        id: node.id,
        ten: node.label,
        maCoQuan: node.maCoQuan,
        isSyncQG: node.isSyncQG,
      };
    },
    formatDonViSuDung(node, instanceId) {
      // console.log("node", node);
      this.formData.donViSuDung = {
        id: node.id,
        ten: node.label,
        maCoQuan: node.maCoQuan,
        isSyncQG: node.isSyncQG,
      };
    },
    formatDonVi(node, instanceId) {
      // console.log("node", node);
      this.formData.donVi = {
        id: node.id,
        ten: node.label,
        maCoQuan: node.maCoQuan,
        isSyncQG: node.isSyncQG,
      };
    },
    normalizer(node) {
      if (node.children == null || node.children == "null") {
        delete node.children;
      }
    },
    loadPhongBan(val) {
      console.log("loadPhongBan", val);
      if (val && val.id) {
        PhongBanGetList(val.id).then((response) => {
          // console.log("response", response);
          this.listPhongBan = response.data;
        });
      } else {
        this.formData.phongBan = null;
      }
      // this.formData.phongBan = {};
    },
    // loadDVSD(val, load) {
    //   console.log("loadDVSD", val, this.valueDonViQuanLy);
    //   if (load != true) {
    //     console.log("------");
    //     this.value = null;
    //     this.listDVSD = [];
    //     this.formData.phongBan = null;
    //     this.listPhongBan = [];
    //   } else {
    //     this.listDVSD = [];
    //   }
    //   if (val && val.id) {
    //     if (val.id == this.infoUser.donVi.id) {
    //       this.listDVSD = this.DM_DONVI;
    //     } else {
    //       GetTreeDVSD(val.id).then((response) => {
    //         // console.log("response", response);

    //         this.listDVSD = response.data;
    //       });
    //     }
    //   } else {
    //     this.value = null;
    //   }
    //   // this.formData.phongBan = {};
    // },
    loadTinh() {
      // console.log("loadTinh");
      this.$store
        .dispatch("common/fetchDiaGioiHanhChinh", null)
        .then((response) => {
          this.listTinh = response;
        });
    },

    loadHuyen(val, key, callBack) {
      if (val) {
        this.$store
          .dispatch("common/fetchDiaGioiHanhChinh", {
            id: val.code,
          })
          .then((response) => {
            this.listHuyen[key] = response;
            if (callBack) {
              callBack(response);
            } else {
              this.formData[key].dictrict = null;
              this.formData[key].commune = null;
            }
          });
      } else {
        this.formData[key].dictrict = null;
        this.formData[key].commune = null;
      }
      // console.log("loadHuyen", this.listHuyen);
    },
    loadXa(val, key, callBack) {
      // console.log("loadXa", val);
      if (val) {
        this.$store
          .dispatch("common/fetchDiaGioiHanhChinh", {
            id: val.code,
          })
          .then((response) => {
            this.listXa[key] = response;
            if (callBack) {
              callBack(response);
            } else {
              this.formData[key].commune = null;
            }
          });
      } else {
        this.formData[key].commune = null;
      }
      // console.log("loadXa", this.listXa);
    },
    async onSubmit() {
      if (this.isWait) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Notification",
            icon: "CoffeeIcon",
            variant: "info",
            text: "In Progress",
          },
        });
      } else {
        // console.log("this.formData", this.formData);
        if (!this.formData.laDangVien) this.formData.laDangVien = false;
        console.log("dataCBCC", this.formData);
        if (this.formData.id && this.formData.id != "") {
          //Update
          this.isWait = true;
          var res = await dataUpdate(this.formData);
          this.isWait = false;
          if (res.isError) {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Thất bại",
                icon: "AlertTriangleIcon",
                variant: "error",
                text: res.message,
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Thành công",
                icon: "CheckIcon",
                variant: "success",
                text: res.message,
              },
            });
            this.$emit("update:is-show-left-sidebar", false);
            this.$emit("refetch-data", this.formData);
          }
        } else {
          //Create
          this.isWait = true;
          var res = await dataCreate(this.formData);
          this.isWait = false;
          if (res.isError) {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Thất bại",
                icon: "AlertTriangleIcon",
                variant: "error",
                text: res.message,
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Thành công",
                icon: "CheckIcon",
                variant: "success",
                text: res.message,
              },
            });
            this.formData.id = res.data.id;
            this.$emit("update:is-show-left-sidebar", false);
            this.$emit("refetch-data", this.formData);
          }
        }
      }
    },
  },
  setup(props, { emit }) {
    const { refFormObserver, getValidationState, resetForm } = formValidation(
      () => {
        //Reset form
      }
    );

    return {
      refFormObserver,
      getValidationState,
      resetForm,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

#add-can-bo-sidebar {
  width: 90%;

  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
